import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isUnauthorizedApiClientError } from 'api/client/isUnauthorizedApiClientError';
import { useToast } from 'app/hooks/useToast';
import { useAnalyticsHealthQuery } from 'app/modules/analytics/hooks/useAnalyticsHealthQuery';

/** Mounted once, so one failed health fetch raises one toast rather than one per reader. */
const AnalyticsHealthDriver: FC = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { isError, error, errorUpdatedAt } = useAnalyticsHealthQuery();

  useEffect(() => {
    if (!isError || isUnauthorizedApiClientError(error)) {
      return;
    }
    toast(error?.userMessage ?? t('somethingWentWrong'), 'error');
  }, [isError, errorUpdatedAt, error, toast, t]);

  return null;
};

export default AnalyticsHealthDriver;
